module.exports = __webpack_public_path__ + "img/appAsset-brand--nfe.f1deb95b.svg";